export default "__VITE_ASSET__Cw6E9sOX__"